import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ReactComponent as AddIcon } from 'assets/icon-add.svg';
import { colors } from 'shared/defaultTheme';
import { allowedExtensions, validExtensionTypes } from 'shared/utils';
import { SpanCustom, ButtonUploaderFilesWrapper } from './styles';

const ButtonFileUploaders = ({ className, onChangeFile, onError, title, isIcon }) => {
  const { t } = useTranslation();
  const fileInputRef = useRef();

  const callOnChangeFile = (files) => {
    const validTypes = validExtensionTypes;
    const existFiles = files.map((file) => {
      const existExtensions = validTypes.some(
        (x) => file.name.toUpperCase().endsWith(x) || file.name.toLowerCase().endsWith(x)
      );
      if (!existExtensions) {
        onError(t('general_invalid_file_type'));
        const newFile = file;
        newFile.isValidFile = false;
        return newFile;
      }
      onError('');
      const newFile = file;
      newFile.isValidFile = true;
      return newFile;
    });
    onChangeFile(existFiles);
  };

  const onClickUploadSection = () => {
    fileInputRef?.current?.click();
  };

  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };

  const fileDrop = (e) => {
    e.preventDefault();
    const { files } = e.dataTransfer;
    const newFiles = [...files];
    callOnChangeFile(newFiles);
  };

  const fileSelected = (e) => {
    if (fileInputRef.current.files.length) {
      const { files } = fileInputRef.current;
      const newFiles = [...files];
      callOnChangeFile(newFiles);
      e.target.value = '';
    }
  };

  return (
    <>
      <ButtonUploaderFilesWrapper className={classNames(['image-uploader', { className }])}>
        <div
          onClick={onClickUploadSection}
          aria-hidden="true"
          onDragOver={dragOver}
          onDragEnter={dragEnter}
          onDragLeave={dragLeave}
          onDrop={fileDrop}
          className={classNames(['button-uploader-container'], {})}
        >
          {isIcon && (
            <div className="pl-2 button-uploader-info">
              <AddIcon className="" fill={colors.black} />
              <SpanCustom className="span-custom-title">{title}</SpanCustom>
            </div>
          )}
          {!isIcon && (
            <div>
              <SpanCustom className="span-custom-title">{title}</SpanCustom>
            </div>
          )}
        </div>
        <input
          ref={fileInputRef}
          type="file"
          onChange={fileSelected}
          multiple
          accept={allowedExtensions}
        />
      </ButtonUploaderFilesWrapper>
    </>
  );
};

ButtonFileUploaders.defaultProps = {
  className: '',
  onError: (error) => error,
  isIcon: true,
};

ButtonFileUploaders.propTypes = {
  className: PropTypes.string,
  onChangeFile: PropTypes.func.isRequired,
  onError: PropTypes.func,
  title: PropTypes.string.isRequired,
  isIcon: PropTypes.bool,
};

export default ButtonFileUploaders;
